import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'contractTerminationTypeTransform' })
export class ContractTerminationTypeTransformPipe implements PipeTransform {
  static readonly contractTerminationTypeMap = new Map([
    [0, 'Contract.TerminationType.TerminatedByUser'],
    [1, 'Contract.TerminationType.TerminatedByInsurance'],
    [2, 'Contract.TerminationType.AutomaticallyTerminated'],
  ]);

  static readonly contractTerminationTypeInSentenceMap = new Map([
    [0, 'Contract.TerminationType.TerminatedByUserInSentence'],
    [1, 'Contract.TerminationType.TerminatedByInsuranceInSentence'],
    [2, 'Contract.TerminationType.AutomaticallyTerminatedInSentence'],
  ]);

  transform(contractTerminationType: number | undefined, ...args: string[]): string {
    if (contractTerminationType == null) {
      return '';
    }

    let map: Map<number, string> | null = null;

    if (args[0] === 'InSentence') {
      map = ContractTerminationTypeTransformPipe.contractTerminationTypeInSentenceMap;
    } else if (args.length === 0) {
      map = ContractTerminationTypeTransformPipe.contractTerminationTypeMap;
    }

    return map?.get(contractTerminationType) ?? '';
  }
}
